import { useCountDown } from 'ahooks';
import { Options, FormattedRes } from 'ahooks/lib/useCountDown';
import { useEffect, useState } from 'react';
import { atom, useAtom } from 'jotai';

export const countdownState = atom<FormattedRes | null>(null);

const useShopeeCountdown = (options: Omit<Options, 'targetDate'>) => {
  const [targetDate, setTargetDate] = useState<number | undefined>();
  const [, formattedRes] = useCountDown(Object.assign({}, options, { targetDate }));
  const [pending, setPending] = useState(false);
  const [countdown, setCountdown] = useAtom(countdownState);

  const startCountdown = (ms: number) => {
    if (pending) return;
    setPending(true);
    setTargetDate(Date.now() + ms);
  };

  const stopCountdown = () => {
    setPending(false);
    setTargetDate(undefined);
    setCountdown(null);
  };

  useEffect(() => {
    setCountdown(formattedRes);
  }, [formattedRes, setCountdown]);

  return {
    startCountdown,
    stopCountdown,
    countdown,
  };
};

export default useShopeeCountdown;
